import {
  AssessmentButton,
  IStyles,
  pxToRem,
  getLocalStorage,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Box } from '@mui/material';
import { getRoundedDownValue } from '../../../utils/functions';
import { ModuleSchoolContentStatsData } from '@protos/learning_management/lms.common.apis_pb';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { useEffect, useState } from 'react';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';

const styles: IStyles = {
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { md: 'space-between' },
    gap: { xs: pxToRem(31), md: 0 },
  },
};
interface IProps {
  createClickHandler: () => void;
  libraryClickHandler: () => void;
  hwCount?: number;
}
export default function AssementRedirectionComponent(props: IProps) {
  const { createClickHandler, libraryClickHandler, hwCount } = props;

  const teacher_profile_id = getLocalStorage('userId');
  const { LmsCommonAPIServiceV1ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();
  const { class_subject_info } = useAppSelector((state) => state.homeDashboard);

  const [schoolContentStats, setSchoolContentStats] = useState<
    ModuleSchoolContentStatsData | undefined
  >();

  const getContentStats = async () => {
    try {
      const response =
        await LmsCommonAPIServiceV1ClientWithStatusCodeHandler.getModuleSchoolContentStats(
          {
            personId: teacher_profile_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            subjectId: class_subject_info?.subjectId,
          }
        );
      if (response.code === 200) {
        setSchoolContentStats(response.data);
      }
    } catch (error) {
      console.log('error:', error);
    }
  };

  useEffect(() => {
    getContentStats();
  }, [class_subject_info]);

  return (
    <Box sx={styles.root}>
      <AssessmentButton
        backgroundColor="#FFDD7B"
        imageName="working-person-group"
        clickHandler={createClickHandler}
        variant="regular"
        heading={{ bold: 'Create', regular: 'Assessment' }}
        headingData={[
          ...(schoolContentStats?.questionCount
            ? [
                {
                  value: getRoundedDownValue(schoolContentStats.questionCount),
                  text: 'Questions',
                },
              ]
            : []),
          ...(schoolContentStats?.learningOutcomeCount
            ? [
                {
                  value: getRoundedDownValue(
                    schoolContentStats.learningOutcomeCount
                  ),
                  text: 'Learning Outcomes',
                },
              ]
            : []),
        ]}
      />

      <AssessmentButton
        backgroundColor="#CBEECD"
        imageName="library-group"
        clickHandler={libraryClickHandler}
        variant="regular"
        heading={{ bold: 'Choose', regular: 'From Library' }}
        headingData={[
          ...(schoolContentStats?.assessmentCount !== undefined
            ? [
                {
                  value: getRoundedDownValue(
                    schoolContentStats.assessmentCount
                  ),
                  text: 'Ready Assessments',
                },
              ]
            : []),
        ]}
      />
    </Box>
  );
}
